import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Where an invite link points: `/join?code=ABC123`.
 *
 * It is not a screen. The gate in `__root` shows the join screen for anyone
 * who is signed in and in no household, whatever the URL says. So by the time
 * this route's component would render, joining has already happened — and what
 * is left is a spent invite link that has to land somewhere sensible.
 *
 * Existing as a route at all is the point: without it, the moment a join
 * succeeds the gate hands control to the router and `/join` matches nothing.
 *
 * **This redirect runs on the router's first pass, long before anyone signs
 * in, and it does not carry the query string.** That is why the join screen
 * cannot read the code from the URL and `lib/invite.ts` captures it at module
 * load instead. Dropping the code here is now deliberate rather than
 * incidental: a live single-use code has no business staying in the address
 * bar, in history, or in a screenshot of either.
 */
export const Route = createFileRoute("/join")({
  beforeLoad: () => {
    throw redirect({ to: "/tasks", replace: true });
  },
});
